<template>
  <div
    class="notification-drawer -mx-6 -mt-4 -mb-6 min-h-[400px] max-h-[70vh] flex flex-col bg-gray-950 rounded-t-lg overflow-hidden border-t border-gray-800 shadow-2xl">
    <!-- Header -->
    <div
      class="flex items-center justify-between px-5 py-4 border-b border-gray-800 bg-gray-900/80 backdrop-blur-sm">
      <h2 class="text-lg font-bold text-white">Notifications</h2>
      <div class="flex gap-2 items-center">
        <button
          v-if="unreadCount > 0"
          class="text-xs text-gray-300 hover:text-white px-3 py-1.5 rounded-md hover:bg-gray-800 border border-gray-700/50 hover:border-gray-600 transition-all font-medium"
          @click="markAllAsRead">
          Mark all read
        </button>
        <router-link
          :to="{ name: 'WebNotifications' }"
          class="text-xs text-blue-400 hover:text-blue-300 px-3 py-1.5 rounded-md hover:bg-gray-800 border border-gray-700/50 hover:border-blue-500/30 transition-all font-medium"
          @click="$emit('close')">
          See all
        </router-link>
      </div>
    </div>

    <!-- Content -->
    <div class="overflow-y-auto flex-1 bg-gray-950">
      <NotificationList
        :notifications="notifications"
        :loading="loading"
        :loading-more="loadingMore"
        :has-more="hasMore"
        @load-more="loadMore"
        @notification-click="handleNotificationClick" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useStoreNotifications } from '@/stores/storeNotifications'
import NotificationList from './NotificationList.vue'

const emit = defineEmits(['close'])

const storeNotifications = useStoreNotifications()

// Computed props from store
const notifications = computed(() => storeNotifications.notifications)
const loading = computed(() => storeNotifications.loading)
const loadingMore = computed(() => storeNotifications.loadingMore)
const hasMore = computed(() => storeNotifications.hasMore)
const unreadCount = computed(() => storeNotifications.unreadCount)

// Actions
const loadMore = () => {
  storeNotifications.loadMore()
}

const markAllAsRead = async () => {
  await storeNotifications.markAllAsRead()
}

const handleNotificationClick = () => {
  emit('close')
}

// Fetch notifications on mount
onMounted(() => {
  if (!storeNotifications.loaded) {
    storeNotifications.fetch()
  }
})
</script>

<style scoped>
.notification-drawer {
  height: 60vh;
  min-height: 400px;
}
</style>
